import type { PopulationId } from "visumo-data-agent-web-shared";
import { HelpIcon } from "../help/HelpIcon";
import { PopulationSelect } from "./PopulationSelect";

export function UgcPopulationSelect({
  population,
  minimum,
  onChange,
}: {
  population: PopulationId;
  minimum: number;
  onChange: (population: PopulationId, minimum: number) => void;
}) {
  return (
    <div className="vd-stack">
      <span className="vd-row">
        <label className="vd-check">
          <input
            type="checkbox"
            checked={population === "WITH_UGC"}
            onChange={(event) =>
              onChange(event.target.checked ? "WITH_UGC" : "ALL", minimum)
            }
          />
          <span>UGC の件数で母数を絞る</span>
        </label>
        <HelpIcon slug="getting-started/population" />
      </span>
      {population === "WITH_UGC" ? (
        <label className="vd-field">
          <span className="vd-field-hint">UGC 件数の下限</span>
          <select
            className="vd-select"
            value={minimum}
            onChange={(event) =>
              onChange(population, Number(event.target.value))
            }
          >
            <option value={1}>1 件以上</option>
            <option value={50}>50 件以上（水曜のデモ対象）</option>
          </select>
        </label>
      ) : (
        <PopulationSelect
          value={population}
          onChange={(next) => onChange(next, minimum)}
        />
      )}
      {population === "WITH_UGC" ? (
        <p className="vd-stat-note">
          UGC {minimum} 件以上で絞った母数です。件数は取得した結果に表示します。
        </p>
      ) : null}
    </div>
  );
}
